jQuery(document).ready(($) => {

    var bottleBasicsIndex = [
        'mouth',
        'overflow-capacity',
        'neck-finish',
        'threads',
        'bead',
        'standard-capacity',
        'shoulder',
        'label-panel',
        'wall',
        'base',
        'deco-lugs'
    ];

    hideHighlights();

    $("#accordion__bottle-basics .pane__header button").click(function() {

        if($(this).attr('aria-expanded') == 'false'){
            hideHighlights();
            var termTarget = $(this).attr('data-target');
            termTarget = termTarget.match(/--([^ ]*)/)[1];
            
            $('#bottle-basics-svg [id^="' + termTarget +'"]').attr('class', '');
        }else{
            hideHighlights();
        }
    });

    function hideHighlights() {
        $.each( bottleBasicsIndex, function( key, value ) {
            $('#bottle-basics-svg [id^="' + value +'"]').attr('class', 'd-none');
        });
    };

});